export default "__VITE_ASSET__D24uztQ5__"